<script setup>
import { computed } from 'vue';
import { useMenuState, generateMenuItemId } from '@/composables/useMenuState';

const propsSubmenu = defineProps({
  titleSubmenu: {
    type: String,
    default: 'Submenu',
  },
  /** Optional stable ID; auto-generated if not provided */
  itemId: {
    type: String,
    default: '',
  },
});

const { isItemOpen, toggleItem } = useMenuState();

// Resolve the unique ID for this submenu
const resolvedId = computed(() => propsSubmenu.itemId || generateMenuItemId());

const isOpen = computed(() => isItemOpen(resolvedId.value));

const toggleSubmenu = (event) => {
  event.stopPropagation();
  toggleItem(resolvedId.value);
};

defineExpose({
  propsSubmenu,
  isOpen,
  toggleSubmenu,
  resolvedId,
});
</script>
<template>
  <ul class="dropdown-submenu navigation">
    <li class="dropdown m-0" :class="{open: isOpen}">
      <div class="d-flex align-items-center justify-content-start rounded m-0 submenu-dropdown-toggle" @click.stop="toggleSubmenu">
        <i class="fa-regular fa-circle mx-1"></i>
        <span class="menu-title text-truncate py-1">{{ propsSubmenu.titleSubmenu }}</span>
        <i class="fa-solid fa-chevron-right fa-2xs px-1 button"></i>
      </div>
      <slot></slot>
    </li>
  </ul>
</template>
<style scoped>
.button {
  transform-origin: center;
  flex-shrink: 0;
  transition: transform .15s ease-in-out;
  will-change: transform;
  margin-left: auto;
}

.dropdown.open .button {
  transform: rotate(90deg);
}

.submenu-dropdown-toggle {
  transition: 0.5s ease-in-out;
  margin-right: 15px;
  cursor: pointer;
  user-select: none;
}

.dropdown.open>.submenu-dropdown-toggle {
  background-color: rgba(138, 138, 138, 0.11);
  transition: 0.5s ease-in-out;
}

.dropdown>i {
  visibility: hidden;
}

#iconSubmenu {
  font-size: 1rem;
}

.dropdown-submenu {
  width: 230px;
  cursor: pointer;
  overflow: hidden;
}

/* Controla exibição do conteúdo do submenu */
.dropdown-submenu :deep(> li > ul),
.dropdown-submenu :deep(.navigation) {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  display: block;
}

.dropdown.open :deep(> li > ul),
.dropdown.open :deep(.navigation) {
  max-height: 500px;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu .dropdown-submenu .menu-title {
  height: 0px;
  visibility: hidden;
}

.vertical-layout.vertical-menu-modern.menu-collapsed .main-menu.expanded .dropdown-submenu .menu-title {
  height: auto;
  visibility: visible;
}
</style>